import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from "react-router-dom";

function Quotes() {
    const { t } = useTranslation();

    document.title = `Yoda - ${t('app.quotes')}`;

    return (
        <div className="Quote">
            <Outlet />
        </div>
    );
}

export default Quotes;
